import styled from 'styled-components';

export const MobileBottomContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2000;
`;
